import React from "react"
import { alertSuccess } from "~utils/alert"
import useNavigation from "~hooks/useNavigation"
import { UpdateForm } from "~components/update-form"
import { useStores } from "~models"
import { Event, EventNames, ChatUpdateData, FLAG_ACK } from "~proto"

const UpdateGroupTitle = () => {
  const navigation = useNavigation()
  const {
    eventStore,
    chatStore: { current },
  } = useStores()

  const inputs = [
    {
      inputType: "text-input",
      key: "title",
      label: "名称",
      keyboardType: "default",
      placeholder: "请输入名称",
      defaultValue: current.title,
      clearButtonMode: "while-editing",
    },
  ]
  const modalPageTitle = "修改群聊名称"

  const modalPageSubTitle = "修改群聊名称后，将在群内通知其他成员。"

  const onLeftPress = () => navigation.goBack()

  const handleSubmit = (values) => {
    const evt = new Event<ChatUpdateData>(EventNames.CHAT_UPDATE, {
      chat_id: current.chat_id,
      ...values,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    alertSuccess({ message: "修改成功" })
    navigation.goBack()
  }

  const handleCancel = () => navigation.goBack()

  const disabledFunc = ({ title }) => {
    return title === current.title || !title
  }
  return (
    <UpdateForm
      modalPageTitle={modalPageTitle}
      modalPageSubTitle={modalPageSubTitle}
      onLeftPress={onLeftPress}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      disabledFunc={disabledFunc}
      inputs={inputs}
    />
  )
}

export default UpdateGroupTitle
